import { FlowBuilder } from "../FlowBuilder";
import {
    getFlowWithBranch,
    getFlowWithEndOrError,
    getFlowWithMultipleSequences,
    getFlowWithNoSteps,
    getFlowWithSteps,
} from "../Testing/TestDataSetup";
import { getFilledDataDefinition } from "../../rule-engine-core/Common/Data/DataTestData";
import { FlowSequenceCompleteStrategy } from "../../rule-engine-core/Flow/Structure/FlowSequenceCompleteStrategy";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";

export const FlowBuilderStories = [
    new StoryNode(
        () => {
            let flow = getFlowWithNoSteps();
            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "No Steps",
    ),
    new StoryNode(
        () => {
            let flow = getFlowWithSteps();

            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "With Steps",
    ),
    new StoryNode(
        () => {
            let flow = getFlowWithNoSteps();

            return (
                <FlowBuilder
                    flow={flow}
                    flowName="Flow Title"
                    viewAPIUrl="http://localhost:6006"
                    onFlowCancel={() => {}}
                    onFlowSave={() => {}}
                />
            );
        },
        "Flow Builder",
        "All Top Bar Controls",
    ),
    new StoryNode(
        () => {
            let flow = getFlowWithSteps();
            flow.allSequences[0].canDelete = false;

            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "Cannot Delete",
    ),
    new StoryNode(
        () => {
            let flow = getFlowWithSteps();
            flow.allSequences[0].canCopy = false;

            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "Cannot Copy",
    ),
    new StoryNode(
        () => {
            let flow = getFlowWithEndOrError();

            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "Flow With End Or Error",
    ),
    new StoryNode(
        () => {
            let flow = getFlowWithMultipleSequences();
            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "Flow With Multiple Sequences",
    ),
    new StoryNode(
        () => {
            let flow = getFlowWithMultipleSequences();
            flow.allSequences[1].strategy = FlowSequenceCompleteStrategy.RETURN_TO_CALLING_STEP;

            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "Return Branches",
    ),
    new StoryNode(
        () => {
            let flow = getFlowWithSteps();
            flow.inputData = getFilledDataDefinition();
            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "With Data",
    ),
    new StoryNode(
        () => {
            let flow = getFlowWithBranch();
            return <FlowBuilder flow={flow} />;
        },
        "Flow Builder",
        "Branch",
    ),
];
